import { render, staticRenderFns } from "./EntityFacts.vue?vue&type=template&id=2371b4fe"
import script from "./EntityFacts.vue?vue&type=script&lang=js"
export * from "./EntityFacts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports